import { ChoicePropertyValue } from "./ChoicePropertyValue";
import type { PropertyValueProps } from "./types";

export const EnumPropertyValue = (props: PropertyValueProps) => <ChoicePropertyValue {...props} multiple={false} />;
